import React from 'react'
import Description from 'components/Slides/Description'

export default Description({
  description: () => (
    <div>
      <p>What about those individual posts? How do they work and how do we display the data for them in our templates?</p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/07-post-intro.js